import 'react-multi-carousel/lib/styles.css';
import { Mission } from '../mission-vision/Mission';
import { Vision } from '../mission-vision/Vision';
import { SunilArora } from '../sunil-arora/SunilArora';
import Testimonial from '../testimonial/Testimonial';
import './AboutUs.scss';
import { Helmet } from "react-helmet-async";
import { CountryFlag } from 'screens/sharedScreen/CountryFlag';

const AboutUs = () => {


    const supplyChainResponsive = {
        superLargeDesktop: {
            // the naming can be any, depends on you.
            breakpoint: { max: 1700, min: 1200 },
            items: 1
        },
        desktop: {
            breakpoint: { max: 1200, min: 992 },
            items: 1
        },
        tablet: {
            breakpoint: { max: 992, min: 768 },
            items: 1
        },
        mobile: {
            breakpoint: { max: 768, min: 0 },
            items: 1
        }
    }

    return (
        <>
            <Helmet>
                <title>About Us | Leading Global Freight Forwarding & Logistics Network</title>
                <meta name="description" content="Discover our mission to connect top freight forwarders worldwide. Learn how our logistics network fosters collaboration and drives sustainable business growth." />
                <meta name="keywords" content="Global Logistics Network, Freight Forwarding Network, International Freight Forwarding, Logistics Partners, Supply Chain Solutions, Freight Forwarding Services, Global Freight Forwarders, Trusted Logistics Network, Business Growth Logistics, Supply Chain Collaboration" />
            </Helmet>

            <div>
                <section className="page-header">
                    <img src="/images/banner/past-event.png" alt="" />
                    <div className="page-header__bg about-banner">
                    </div>
                    <div className="container">
                        <div className="page-header__inner">

                        </div>
                    </div>
                </section>

                <Mission />
                <Vision />
                <CountryFlag />
                <SunilArora />
                <Testimonial />




            </div >
        </>
    )
}

export default AboutUs;
